import { Component, OnInit } from '@angular/core';
import { UserTable } from 'src/app/services/models/user-table.model';
import { UserTableService } from 'src/app/services/user-table.service';

@Component({
  selector: 'bhub-view-tables',
  templateUrl: './view-tables.component.html',
  styleUrl: './view-tables.component.scss',
  standalone: false
})
export class ViewTablesComponent implements OnInit {
  tables: UserTable[] = [];
  loading = false;
  selectedTable: UserTable | null = null;
  showTableView = false;

  constructor(private userTableService: UserTableService) {}

  ngOnInit() {
    this.loadTables();
  }

  loadTables() {
    this.loading = true;
    this.userTableService.getUserTables().subscribe({
      next: (tables) => {
        this.tables = tables;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading tables:', error);
        this.loading = false;
      }
    });
  }

  onViewTable(table: UserTable) {
    this.selectedTable = table;
    this.showTableView = true;
  }

  onBackToList() {
    this.selectedTable = null;
    this.showTableView = false;
  }
}
